/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject.js";
import IntegrationStatus from "@shared/Billing/IntegrationStatus";
import {LocationTypeId} from "@shared/scheduler/LocationTypeId";


export class LocationItem extends DbBaseObject{

	typeId: string = null
	type: ?string = null;
	typeSuggestion: ?string = null;
	coachContact: ?string = null;
	clientContact: ?string = null;
	askInvitee: boolean = false

	isIntegrationAvailable: boolean = false

	generatedMeetingObject: Object = null //this is weher we store the meeting generated by the integrated service, like zoom meeting

	//the below prefixed fields are not stored in the database
	_integrationStatus: string = "NOT_SET"
	_connectedText: string = ""
	_connectButtonTitle: string = ""

	constructor() {
		super();
		// setTimeout is required because when the object is constructed
		// by class-transform library, all properties are empty at this stage so we need to wait one cycle
		setTimeout(() => this.setupIfNeeded())
	}

	locationFormatted(){
		if(this.coachContact && (this.typeId === LocationTypeId.ZOOM || this.typeId === LocationTypeId.GOOGLE_MEET)){
			let contact = this.coachContact.split(" ")[0]
			return `<a href=${this.coachContact} target="_blank">${this.type}<i class="ml-2 fontello icon-link-ext external-link"></i></a>`
		}
		let location = this
		let res = ""
		let type = location.type || ""
		if(type.length > 0){
			type += ", "
		}
		let coachContact = location.coachContact
		let clientContact = location.clientContact
		res += `${type} ${clientContact || coachContact || ""}`
		if(clientContact && coachContact){
			res += ` (coach's contact: ${coachContact})`
		}
		return res || 'Not provided'
	}

	toString(){
		return this.locationFormatted()
	}

	isIntegrated(){
		return this._integrationStatus === IntegrationStatus.INTEGRATED
	}

	setupIfNeeded(){
		// console.log("LocationItem: setupIfNeeded, ", Object.assign({}, this))
		// console.log("LocationItem: this.typeId = ", this.typeId)
		if(!this.typeId) {
			// console.log("LocationItem: typeId is null. this.type = ", this.type)
			switch (this.type) {
				case "Zoom meeting":
					console.log("LocationItem: it's Zoom meeting")
					this.typeId = LocationTypeId.ZOOM
					this.isIntegrationAvailable = true
					break;
				case "Google Meet":
					console.log("LocationItem: it's Google meet")
					this.typeId = LocationTypeId.GOOGLE_MEET
					this.isIntegrationAvailable = true
					break;
			}
		}

	}
}
